<template>
  <div class="block-about">
    <bim-row  class="block-about__description description mt-11">
      <bim-text type="main" class="description__line">
        BIMLIB —  это экосистема сервисов для обеспечения участников инвестиционно-строительных проектов инструментами эффективного принятия решений на основе актуальной, обоснованной и взаимосвязанной инженерной информации.
      </bim-text>
      <bim-text type="main" class="description__line pt-11">
        Платформа основана в 2015 году и призвана стать ежедневным удобным инструментом для профессионалов строительной отрасли.
      </bim-text>
    </bim-row>
    <BlockList class="mt-12" :list="our_services" />
    <BlockList class="mt-12" :list="achivmentes" />
  </div>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"

import BlockList from "./BlockList"
export default {
  name: "BlockContent_About",
  components: {
    bimRow,
    bimCol,

    BlockList
  },
  data() {
    return {
      our_services: {
        title: "Наши сервисы",
        items: [
          {
            title: "Инженерам сервис помогает:",
            items: [
              "использовать готовые <a rel='nofollow' class='block-about__link' href='/models/?from=about' target='_blank'>BIM-компоненты и модели для дополненной реальности</a> от производителей;",
              "сравнивать продукцию на основе актуальных инженерных данных напрямую в САПР;",
              "мгновенно находить несколько вариантов продукции по САПР-параметрам;",
              "выгружать спецификации в PDF по форме ГОСТ с гиперссылками на страницу продукции;",
              "экономить время, автоматически записывая параметры реальной продукции на исходный объект модели."
            ]
          },
          {
            title: "Сметчикам платформа обеспечивает:",
            items: [
              "создание или импорт смет для обновления;",
              "актуальные цены на момент обновления;",
              "автоматический подбор прайс-листа для тома обоснования расценки в смете; ",
              "привязку материалов к расценкам ФЕР / ТЕР / ТСН / ИСН на основе готовых предложений онлайн;",
              "автоматическое формирование Сметной документации по МДС 81-35 и ПП 87 с томами обоснования;",
              "удобную разработку индивидуальных сметных норм для заказчика или генерального подрядчика."
            ]
          },
          {
            title: "Производителям сервис предоставляет:",
            items: [
              "статистику об использовании продукции в проектах;",
              "возможность общения с инженерами;",
              "<a rel='nofollow' href='/bim/?from=about' class='block-about__link' target='_blank'>разработку BIM-компонентов</a> продукции и собственных библиотек для дальнейшего использования в рамках «проектных продаж»;",
              "<a rel='nofollow' href='/ar/?from=about' class='block-about__link' target='_blank'>разработку моделей для дополненной реальности</a>;",
              "<a rel='nofollow' href='/dev/?from=about' class='block-about__link' target='_blank'>возможность аудита и разработки программных решений для инженеров</a>;",
              "разработку собственных технологических карт с пооперационным контролем для строительного контроля."
            ]
          },
          {
            title: "Поставщикам строительных ресурсов сервис предоставляет:",
            items: [
              "<a rel='nofollow' href='/smpp/?from=about' class='block-about__link' target='_blank'>детальную информацию о проектной потребности на ранних стадиях</a>;",
              "плановую стоимость ресурсов объекта, при наличии;",
              "возможность общения со сметчиками;",
              "разработку собственных технологических карт с пооперационным контролем для строительства."
            ]
          }
        ]
      },
      achivmentes: {
        title: "Наши текущие достижения",
        items: [
          {
            title: "<a rel='nofollow' href='https://www.buildingsmart.org/?from=bimlib.pro' class='block-about__link' target='_blank'>buildingSMART International</a> <span style='font-size:14px;font-weight:normal;'>*до 2021 года</span>",
            items: [
              "официальные провайдеры сервисов buildingSMART Data Dictionary (bSDD);",
              "выполняем работу по улучшению международных сервисов взаимосвязанных словарей данных bSDD;",
              "систематизируем разработку API словарей bSDD;",
              "участвуем в рабочих группах bSI;"
            ]
          },
          {
            title: "<a rel='nofollow' href='https://buildingsmart.su/?from=bimlib.pro' class='block-about__link' target='_blank'>buildingSMART Russia</a> <span style='font-size:14px;font-weight:normal;'>*до 2021 года</span>",
            items: [
              "входим в состав экспертного жюри конкурса <a rel='nofollow' href='https://www.buildingsmart.org/bsi-awards/?from=bimlib.pro' class='block-about__link' target='_blank'>buildingSMART Awards 2020</a>;",
              "возглавляем рабочую группу по разработке терминологии и описанию свойств продукции в строительстве;",
              "формируем общее развитие открытых стандартов"
            ]
          },
          {
            title: "Министерство экономического развития РФ",
            items: [
              "являемся экспертами Комиссии по рассмотрению предложений в сфере BIM-технологий, цифровизации, государственной регистрации прав на недвижимость, кадастрового учёта."
            ]
          },
          {
            title: "Министерство промышленности и торговли РФ",
            items: [
              "выполнили интеграцию <a rel='nofollow' href='https://gisp.gov.ru/bimlib/landing/?from=bimlib.pro' class='block-about__link' target='_blank'>BIMLIB с ГИС «Промышленность»</a>;",
              "ведём совместную работу по систематизации данных от производителей."
            ]
          },
          {
            title: "ГК Росатом",
            items: [
              "готовим совместный проект внедрения технологии bSDD в подразделения госкорпорации;",
              "являемся экспертами, провайдерами и техническими партнёрами <a rel='nofollow' href='https://bim-wcc.ru/?from=bimlib.pro' class='block-about__link' target='_blank'>командной номинации</a> по информационному моделированию Международного строительного чемпионата <a rel='nofollow' href='https://pro-wcc.ru/?from=bimlib.pro' class='block-about__link' target='_blank'>WCC2020</a>;",
              "выступали экспертами и провайдерами двух номинаций по информационному моделированию VI и VII конкурсов профессионального мастерства «Лучший по профессии в стройкомплексе атомной отрасли», ОЦКС «Росатом», <a rel='nofollow' href='https://bimlib.pro/articles/luchshie-po-professii-poluchili-nagradi-po-itogam-vii-ezhegodnogo-konkursa-goskorporacii-rosatom-474' class='block-about__link' target='_blank'>2018-2019</a> гг."
            ]
          },
          {
            title: "<a rel='nofollow' href='https://nacec.ru/?from=bimlib.pro' class='block-about__link' target='_blank'>НАИКС</a>",
            items: [
              "являемся членами ассоциации с 2018 года;",
              "работаем как активные участники рабочих групп ассоциации;",
              "выступаем экспертами на комиссиях и международных форумах."
            ]
          },
          {
            title: "<a rel='nofollow' href='http://natamac.ru/?from=bimlib.pro' class='block-about__link' target='_blank'>НОПСМ</a>",
            items: [
              "являемся членами ассоциации с 2018 года;",
              "в 2020 г. запустили совместную <a rel='nofollow' href='https://bimlib.pro/articles/bonusi-dlya-chlenov-associacii-nopsm-625' class='block-about__link' target='_blank'>партнёрскую программу</a>;",
              "совместное участие в 21-ой всероссийской выставке «Отечественные Строительные Материалы»-2020."
            ]
          },
          {
            title: "Институты развития",
            items: [
              "с 2018 года – участники платформы НТИ;",
              "с 2018 года – <a rel='nofollow' href='https://phystechpark.ru/?from=bimlib.pro' class='block-about__link' target='_blank'>резиденты «Физтехпарк»</a>;",
              "с 2020 года – <a rel='nofollow' href='https://navigator.sk.ru/orn/1123273?from=bimlib.pro' class='block-about__link' target='_blank'>резиденты «Сколково»</a>.",
            ]
          },
          {
            title: "Участники и докладчики:",
            items: [
              "Международный саммит buildingSMART Int;",
              "Autodesk BIM-конгресс;",
              "Академия KNAUF;",
              "Мероприятия Российского союза промышленников и предпринимателей и ТПП РФ;",
              "Глобальный саммит по производству и индустриализации (GMIS);",
              "Smart Energy World Russia;",
              "Конференция Autodesk University Russia 2019;",
              "AstanaBuild 2019;",
              "BIM-форум 2019;",
              "Петербургский международный экономический форум 2019;",
              "Форум «Глобальное технологическое лидерство»;",
              "Форум «BIM. Проектирование. Строительство. Эксплуатация»;",
              "Industrial Transformation Asia Pacific 2019;",
              "Международная строительно-интерьерная выставка BATIMAT RUSSIA 2020;",
              "Вторая конференция «BIM- и BEM- моделирование при проектировании инженерных систем, зданий и сооружений»;",
              "21-ая всероссийская выставка «Отечественные Строительные Материалы»-2020;",
              "BIM-форум 2021;",
              "Международная выставка оборудования для отопления, водоснабжения, вентиляции и климатических систем Engineerica;",
              "Чемпионат WorldSkills Russia 2021.",
            ]
          },
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.description {
  .description__line {
    line-height: 1.5;
    letter-spacing: 0.2px;
    text-align: center;
    width: 55%;
    margin: auto;

    @media screen and (max-width: $breakpoint-sm) {
      width: 100%;
      font-size: 14px;
      text-align: left;
      line-height: 1.57;
    }
  }
}

::v-deep .block-about__link {
  color: $primary-color;

  &:hover {
    opacity: .8;
  }
}

</style>
